import { render } from "./SucursaL.vue?vue&type=template&id=ede9c534&scoped=true"
import script from "./SucursaL.vue?vue&type=script&lang=js"
export * from "./SucursaL.vue?vue&type=script&lang=js"

import "./SucursaL.vue?vue&type=style&index=0&id=ede9c534&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede9c534"]])

export default __exports__